import AttendApplicationApprovalDetail from './AttendApplicationApprovalDetail'

export default AttendApplicationApprovalDetail;
